import { createContext, useContext, useEffect, useState } from "react";
import { consts as constsEng } from "../constsEng";
import { consts as constsHeb } from "../constsHeb";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const getInitialLang = () => localStorage.getItem("lang") || "en";

  const [language, setLanguage] = useState(getInitialLang());
  const [text, setText] = useState(
    getInitialLang() === "he" ? constsHeb : constsEng
  );

  const toggleLanguage = (lang) => {
    setLanguage(lang);
    setText(lang === "he" ? constsHeb : constsEng);
    localStorage.setItem("lang", lang);
  };

  useEffect(() => {
    setText(language === "he" ? constsHeb : constsEng);
    document.documentElement.lang = language;
    document.documentElement.dir = language === "he" ? "rtl" : "ltr";
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, text }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
